import { trackLabel } from '@verybigthings/trackframe-shared/tracks';
export const HEADER_MENU_GROUPS = ['tracks', 'portal', 'account'];
export function headerMenuItems(input) {
    const { tracks, links } = input;
    // Tracks without a `baseUrl` are hidden — the menu is for users navigating
    // between live frontends, not for admins auditing config.
    const trackItems = tracks
        .filter((t) => Boolean(t.baseUrl))
        .map((t) => ({
        group: 'tracks',
        id: `track:${t.id}`,
        title: trackLabel(t),
        url: t.baseUrl,
        description: t.description ?? null,
    }));
    const portalItems = [
        { group: 'portal', id: 'portal', title: 'Portal', url: links.portalHref },
        ...(links.adminHref ? [{ group: 'portal', id: 'admin', title: 'Admin', url: links.adminHref }] : []),
    ];
    const accountItems = [
        { group: 'account', id: 'documents', title: 'My documents', url: links.documentsHref },
        { group: 'account', id: 'integrations', title: 'Integrations', url: links.integrationsHref },
        { group: 'account', id: 'schedules', title: 'Scheduled actions', url: links.schedulesHref },
        { group: 'account', id: 'account', title: 'Account', url: links.accountHref },
    ];
    return [...trackItems, ...portalItems, ...accountItems];
}
/** Items of one group, in order — for callers that render sections. */
export function headerMenuGroup(items, group) {
    return items.filter((i) => i.group === group);
}
//# sourceMappingURL=header-menu-items.js.map